import { alpha } from "@mui/material/styles";
import dayjs from "dayjs";
import { Box, Grid, Typography } from "@mui/material";
import { Eventcalendar } from "@mobiscroll/react";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";

export const CalenderLeft = ({
  firstDay,
  setFirstDay,
  lastDay,
  setLastDay,
  setHideTodayButton,
}) => {
  const leftCalenderSX = (theme) => ({
    "& .mbsc-calendar-today": {
      color: `${theme.palette.primary.main} !important`,
    },
    "& .mbsc-selected": {
      background: `${theme.palette.primary.main} !important`,
    },
    "& .mbsc-selected .mbsc-calendar-cell-text": {
      color: `${theme.palette.primary.contrastText} !important`,
    },
    "& .mbsc-calendar-wrapper": { border: "none !important" },
    "& .mbsc-event-list": { display: "none" },
    "& .mbsc-calendar-header": { display: "none" },
  });

  const leftCalenderView = {
    calendar: { type: "month" },
    agenda: { type: "month" },
  };

  return (
    <Grid
      size={2.5}
      sx={(theme) => ({
        borderRadius: "10px",
        overflow: "hidden",
        bgcolor: "white",
        px: "1rem",
        ...leftCalenderSX(theme),
      })}
    >
      <Box sx={{ px: "1rem" }}>
        <Typography component="p" variant="h1" sx={{ marginBottom: "-.1em" }}>
          {dayjs(firstDay).format("D")}
        </Typography>
        <Typography component="p" variant="subtitle1" sx={{ mb: "20px" }}>
          {dayjs(firstDay).format("dddd, MMMM YYYY")}
        </Typography>
      </Box>
      <Eventcalendar
        view={leftCalenderView}
        onCellClick={(e) => {
          const firstDay = dayjs(e?.date).format("YYYY-MM-DD");
          const lastDay = dayjs(e.firstDay).format("YYYY-MM-DD");
          const hideButton =
            dayjs(firstDay).format("D-MMM-YYYY") ===
            dayjs().format("D-MMM-YYYY");

          setFirstDay(firstDay);
          setLastDay(lastDay);
          setHideTodayButton(hideButton);
        }}
        clickToCreate={false}
        dragToCreate={false}
        dragToMove={false}
        dragToResize={false}
        eventDelete={false}
        selectedDate={firstDay}
        data={[]}
        themeVariant="light"
        renderAgenda={() => null}
      />
    </Grid>
  );
};
